export const reset: (resetPrivacyPolicy?: boolean) => void = async (resetPrivacyPolicy = true) => {
  // use dynamic imports so it will not bundle this into the root JS
  if (resetPrivacyPolicy) {
    const { VirtualMirror } = await import('@luxottica/virtual-mirror')
    VirtualMirror.resetBipaState()
  }

  const { clearPictureVideoIds } = await import('@utils/sessionStorage')
  clearPictureVideoIds()
}
